export default "__VITE_ASSET__KK_MZQPS__"